import type { FaireProductEntity } from "../../entity_types/product";

export const p_c3eihau59b: FaireProductEntity = {
  token: "p_c3eihau59b",
  type: "product",
  name: "Herbal Tea Trio Tin & Spoon - Organic, Fair-Trade Tea Gift",
  brandToken: "b_cwa13pfnx9",
  brandName: "JusTea (No Import Fees to USA)",
  imageUrl:
    "https://cdn.faire.com/fastly/44eb7d1e99a1466257f6027848f25799a4d01c07ae25adf8861098086a3cddff.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/23c0593fd689c1e8701b7f740fd67cd1d8b6c60f581496a7df5aa18cd49f8132.jpeg",
    "https://cdn.faire.com/fastly/c25caab09c7ecb42a1a91b780a89411c59900849f0731eb8c69ab5f1c8e75794.jpeg",
    "https://cdn.faire.com/fastly/f6e3d9445f9171d095c8f2a910d28120f653f0442624e98ea7c35ef72a83bb50.jpeg",
    "https://cdn.faire.com/fastly/ef2bd37f987221c549ff54bf0448b8050e4c68e9baf27601998cb947f64f12fd.jpeg",
    "https://cdn.faire.com/fastly/212d549d81a963d3291d8c2619dd05f613da7b602632b16fb1d02cbe7f45cbb5.jpeg",
    "https://cdn.faire.com/fastly/47f9d5ded7c960f5cdb3995785734024a388ea458231c0d6ca899628d7ce91f9.jpeg",
    "https://cdn.faire.com/fastly/5a8a90d766e4641e116bf95080536e49ae19dd85af405d4917278d272fa7efd5.jpeg",
    "https://cdn.faire.com/fastly/2dd4c8a3acbf5600a5b4cc2e3ece792e6aacb0b435a2382379e72407e2eb8750.jpeg",
  ],
  priceDollars: 12.49,
  description:
    "WHY CUSTOMERS LOVE JUSTEA: Award-winning taste, stand-out packaging, and a farmer-direct story!\n\n3 IN 1 VARIETY PACK: Featuring our top selling Herbal Tea flavours: Chamomile Dream, Little Berry Hibiscus, Peppermint Garden (FKA Detox).\n\nSTAND-OUT PACKAGING: Beautiful stacking tea tins with the farmer's picture/profile and a hand-carved Kenyan spoon.\n\nFARMER-DIRECT STORY: Every purchase directly supports a Women’s Herbal Tea Co-op in Kenya. Justly Made Tea.\n\nHAND-CARVED SPOON: Attached to each tin is a handcrafted, olive-wood tea spoon! Creating sustainable employment for Kenyan artisans.\n\nEARTH-FRIENDLY: Each tin is recyclable or reusable and offers up to 30 cups per flavour (90 cups/trio).\n\nWHOLE LEAF QUALITY: Customers enjoy a fuller flavour and each cup of JusTea can be resteeped for double the value!\n\nHAND-PICKED TEA from Kenya: Organically grown, free of chemicals and pesticides. \n\n100% NATURAL INGREDIENTS: Non-GMO and Fair Trade Federation verified.\n\n2 YEAR SHELF LIFE Guaranteed.",
  tags: [],
  msrpDollars: 24.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:57:50.360Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
